/**
 * UI控件库 
 * @module UI
 */

;(function (ui,$) {
/**
   * <h3>滑动控件</h3>
   * <a href="../../ui_controls/bui.slide.html" target="_blank">demo</a>
   * <p>滑动控件比较灵活,对参数要了解得更多一点,可以用来制作: 焦点图,TAB选项卡,全屏相册,上下滑屏,过滤筛选,层级选择器,滚动公告,等等</p>
   * <h5>全局操作</h5>
   * {{#crossLink "bui.slide/option"}}{{/crossLink}}: 获取设置参数 <br>
   * {{#crossLink "bui.slide/widget"}}{{/crossLink}}: 获取依赖控件 <br>
   * {{#crossLink "bui.slide/start"}}{{/crossLink}}: 自动播放<br>
   * {{#crossLink "bui.slide/stop"}}{{/crossLink}}: 停止自动播放 <br>
   * {{#crossLink "bui.slide/lock"}}{{/crossLink}}: 不允许滑动 <br>
   * {{#crossLink "bui.slide/unlock"}}{{/crossLink}}: 允许滑动 <br>
   * <h5>跳转类方法</h5>
   * {{#crossLink "bui.slide/prev"}}{{/crossLink}}: 是否存在,返回index <br>
   * {{#crossLink "bui.slide/next"}}{{/crossLink}}: 是否存在,返回boolean <br>
   * {{#crossLink "bui.slide/to"}}{{/crossLink}}: 删除数组,返回删除后的数组 <br>
   *  @namespace bui
   *  @class slide
   *  @constructor 
   *  @param {object} option  
   *  @param {string} option.id [控件id]  
   *  @param {string} [option.menu] [如果控制菜单要独立,可以使用id选择器]  
   *  @param {string} [option.children] [如果控制内容要独立,可以使用id选择器, slide嵌套必须使用id ]  
   *  @param {string} [option.prev] [如果控制菜单要独立,可以使用id选择器 ]  
   *  @param {string} [option.next] [如果控制菜单要独立,可以使用id选择器 ]  
   *  @param {number} [option.width] [0 为默认屏幕宽度]   
   *  @param {number} [option.height] [0 为默认屏幕高度]  
   *  @param {string} [option.direction] [ 水平滑动还是纵向滑动 默认: x | y ]  
   *  @param {boolean} [option.swipe] [ 是否允许侧滑,默认允许 true | false ]  
   *  @param {boolean} [option.animate] [ 点击菜单跳转到某个位置是否采用动画 默认: true | false ] 
   *  @param {boolean} [option.scroll] [ 是否允许垂直滚动 false | true , 如果内容是scroll 或者list控件,则需要设置false,不然会导致页面滚动出现问题]  
   *  @param {boolean} [option.fullscreen] [ 是否全屏 默认:false | true ]  
   *  @param {boolean} [option.autopage] [ 是否自动分页 默认:false | true ]  
   *  @param {boolean} [option.autoplay] [ 是否自动播放 默认:false | true ]   
   *  @param {boolean} [option.zoom] [ 保持比例缩放 默认 true | false]  
   *  @param {number} [option.transition] [ transform效果持续时间 ]  
   *  @param {number} [option.interval] [ 自动运行间隔 ]  
   *  @param {boolean} [option.delay] [ 延迟触发,配合distance 例如: slide里面如果是scroll控件,则需要设置delay:true,防止随意拖动触发其它  ]  
   *  @param {number} [option.distance] [ 默认80, 拖拽大于distance才会生效,配合delay可以防止slide又有上下其它事件 ]  
   *  @param {function} [option.callback] [ 点击的回调 ]  
   *  @param {function} [option.onStart] [ 按下去的时候触发 ]  
   *  @param {function} [option.onMove] [ 移动的时候触发 ]  
   *  @param {function} [option.onEnd] [ 松开手指的时候触发 ]  
   *  @example
   *   html:
   *
          <div id="slide" class="bui-slide">
            <div id="slidemain" class="bui-slide-main">
              <ul>
                <li>
                  <img src="images/slideshow.png" alt="">
                  <div class="bui-slide-title">我是图片标题1</div>
                </li>
              </ul>
            </div>
            <div class="bui-slide-head">
              <ul >
                <li>1</li>
              </ul>
            </div>
          </div>
   *      
   *   js: 
   *   
          // 初始化
          var uiSlide = new bui.slide({
                      id:"#slide",
                      height:160
                    })
   *
   *
   */    
  ui.slide = function(option){

        var config = {
            id: "",                          
            menu:".bui-slide-head ul",        
            children:".bui-slide-main ul",   
            prev:".bui-slide-prev",           
            next:".bui-slide-next",           
            width: 0,          
            height: 0,         
            zoom: true,   
            transition: 200,         
            interval: 5000,   
            swipe:true,        
            animate:true,      
            delay: false,      
            distance: 80,      
            direction: "x",    
            autoplay: false,   
            scroll: false,
            fullscreen: false, 
            autopage: false,  
            callback: null,
            onStart: null,
            onMove: null,
            onEnd: null
        };
        //方法
        var module = {
            to: to,
            prev: prev,
            next: next,
            stop: stop,
            start: start,
            lock: lock,
            unlock: unlock,
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(true,{}, config, ui.config.slide, option );

        
        var $id,
            el,
            $inner,
            $menu,
            $menuChildren,
            $children,
            $item,
            $prev,
            $next,
            touch = {},     //保存拖拽的坐标
            length,
            nowIndex,
            interPlay,      //        
            innerWidth,
            innerHeight,
            direction,
            itemWidth,
            itemHeight,
            slideAdaptiveHeight,  //父层自适应的高度
            slideHeight,          
            slideMainHeight,
            uiTouch,
            winWidth,
            winHeight,
            //拖动的默认配置
            dragConfig = {
                x: { },
                y: { }
            }
        //初始化
        init(param);

        //初始化
        function init (option) {
            option = option || param;
            if( option.id ){
                $id = ui.obj(option.id);
            }else{
                ui.hint("slide id不能为空");
                return;
            }
            //初始化index值
            nowIndex = 0;
            //option获取新参数使用
            param = module.config = option;

            direction = option.direction;
            // 屏幕的宽度
            winWidth = document.documentElement.clientWidth; 
            winHeight = document.documentElement.clientHeight; 

            //菜单选择器如果传# 代表这个菜单是独立的,可以跟切换的内容分开
            $menu = option.menu.indexOf("#") > -1 ? $( option.menu ): $id.find( option.menu ).eq(0);
            $menuChildren = $menu.children();

            $prev = option.prev.indexOf("#") > -1 ? $( option.prev ): $id.find( option.prev ).eq(0);
            $next = option.next.indexOf("#") > -1 ? $( option.next ): $id.find( option.next ).eq(0);
            $children = option.children.indexOf("#") > -1 ? $( option.children ): $id.find( option.children ).eq(0);

            //单个滚动的内容
            $item = $children.children();

            //高度rem自适应
            remHeight = option.zoom ? ( parseFloat(option.height)/100 + 'rem'): parseFloat(option.height);
            // 单个焦点图的基本信息是否全屏 offsetTop 会把第一个子元素的margin-top 一起算上
            slideAdaptiveHeight = winHeight - ($("header").height() || 0)- ($("footer").height() || 0) - ($id[0] && $id[0].offsetTop || 0) ;
            slideHeight = option.height == 0 ? slideAdaptiveHeight: remHeight ;
            // tab内容高度
            slideMainHeight = ( $id.find( option.menu ).length ? parseFloat(slideHeight - $menu.height())+'px': parseFloat(slideHeight)+'px' ) ;
            // 判断是否全屏 或者高度自适应, 高度自适应的话要判断菜单是在结构里面还是外面,里面需要减掉menu的高度 
            itemHeight = option.fullscreen ?  parseFloat(winHeight)+'px' : (option.height == 0 ? slideMainHeight: remHeight ) ;
            itemWidth = option.fullscreen ? winWidth : option.width || winWidth ;
            length = $item.length;

            //滑动的宽度
            innerWidth = parseFloat( itemWidth ) * length;
            innerHeight = parseFloat( itemHeight ) * length;

            //初始化宽高
            display();

            dragConfig = {
                x: {
                  swipeDir: "swipeLeft",
                  swipeDir2: "swipeRight",
                  width: parseFloat(itemWidth)
                },
                y: {
                  swipeDir: "swipeUp",
                  swipeDir2: "swipeDown",
                  width: parseFloat(itemHeight)
                }
            }
            //绑定拖拽
            drag();

            if( option.autoplay ){

                // 自动播放
                autoPlay();
            }
            return this;
         }   


         //初始化宽高布局
         function display (argument) {
            
            if( !$id.length ){
              return false;
            }

            //添加状态
            addStatus(nowIndex);

            //初始化方向的位置配置
            var positionInit = {
                x: {
                  parentInitKey: "width",
                  parentInitValue: innerWidth,
                  boxCss: "display:-webkit-box;display:box;-webkit-box-align: start;-webkit-box-pack: center;width:100%;",
                  boxItemCSS: "-webkit-box-flex:1;box-flex:1;width:"+itemWidth+"px;height:"+itemHeight+";"+(param.scroll ? "overflow-y:auto;": "overflow:hidden;")
                },
                y: {
                  parentInitKey: "height",
                  parentInitValue: innerHeight,
                  box: "display:-webkit-box;display:box;-webkit-box-align: start;-webkit-box-pack: center;width:100%;-webkit-box-orient: vertical;box-orient: vertical;",
                  boxItemCSS: "-webkit-box-flex:1;box-flex:1;width:"+itemWidth+"px;height:"+itemHeight+";"+(param.scroll ? "overflow-y:auto;": "overflow:hidden;")
                }
            }
            
            //内容总高度
            $children.parent()[positionInit[direction]["parentInitKey"]]( positionInit[direction]["parentInitValue"] );

            var i,l = $item.length;
                for( i = 0; i<l; i++){
                    $item[i].style.cssText = positionInit[direction]["boxItemCSS"];
                }

            $children[0].style.cssText = positionInit[direction]["boxCss"];

            //初始化宽度
            $id.css({
              "position":"relative",
              "overflow":"hidden",
              "width":itemWidth+"px",
              //"height": slideHeight
            });
              
            //是否是全屏
            if( param.fullscreen ){
              $("main").css({
                "position":"static"
              })
              $id.addClass('bui-slide-fullscreen').css({
                "position":"absolute",
                "top":0,
                "left":0,
                "right":0,
                "bottom":0,
                "z-index":110
              })

              $item.addClass('bui-box-center');
            }

            //自动分页
            if( param.autopage ){
              var length = $item.length;
              var initIndex = $children.find(".active").index()+1;
              var pageHtml = templatePage(length,initIndex);
              $id.append(pageHtml);

              $menuChildren = $id.find( param.menu ).eq(0).children();
            }

            /* 事件绑定
            ------------------------------------
             */
            //增加激活样式
            if( $menuChildren.length > 0 ){
                // //绑定菜单
                $menuChildren.off("click.bui").on("click.bui",function (e) {
                    var active = $(this).hasClass("active");
                    var index = $(this).index();

                    if( !active ){

                        if( param.animate ){
                            //跳转到对应的位置
                            to(index);
                        }else{
                            to(index,"none");
                        }
                        
                        //添加激活的状态
                        addStatus(index);

                        if( param.autoplay ){
                          // 如果是自动播放,需要先清除原来的时间重新计算
                          autoPlay();
                        }
                    }
                })
            }

            //绑定左右按钮
            if( $prev.length > 0 ){
                
                //绑定菜单
                $prev.off("click.bui").on("click.bui",function (e) {
                    prev();

                    e.stopPropagation();
                })
                
            }
            if( $next.length > 0 ){
                //绑定菜单
                $next.off("click.bui").on("click.bui",function (e) {
                    next();

                    e.stopPropagation();
                })
            }

            //点击以后的回调
            param.callback && $item.off("click.bui").on('click.bui',function (e) {

                var self = this;

                param.callback.call(self,e,module);
            })
         }
         

         //绑定拖拽
         function drag (argument) {
            if( !$children.length ){
                return false;
            }

            uiTouch = ui.touch({
              id: $children,
              handle: $item,
              onStart: onstart,
              onMove: onmove,
              onEnd: onend
            });

            //关闭拖拽
            if( !param.swipe ){

              uiTouch.off();
            }
         }

           
         function onstart(e,touch) {
              itemWidth = parseFloat(itemWidth);
              itemHeight = parseFloat(itemHeight);

              // 如果是自动播放,需要先清除原来的时间重新计算
              if( param.autoplay ){
                  stop();
              }
              //开始的时候计算
              param.onStart && param.onStart.call(this,e,touch,module);

              // 导致slide 里面的元素的点击,需要触发2次
              // e.stopPropagation();
                          
          }
         
         function onmove (e,touch) {
           
            //当前坐标
            var index = $(this).index(),
                scrollLeft = -index * itemWidth,
                scrollHeight = -index * itemHeight,
                deltaX = touch.x2-touch.x1,
                deltaY = touch.y2-touch.y1;

              dragConfig["x"]["move"] = scrollLeft + deltaX;
              dragConfig["x"]["absDelta"] = Math.abs(deltaX);

              dragConfig["y"]["move"] = scrollHeight + deltaY;
              dragConfig["y"]["absDelta"] = Math.abs(deltaY);

            if( touch.direction === dragConfig[direction]["swipeDir"] || touch.direction === dragConfig[direction]["swipeDir2"]  ){
              
              if( param.delay && dragConfig[direction]["absDelta"] > param.distance){

                  transform( dragConfig[direction]["move"],"none" );
              }
              //拖动效果马上可见
              if( !param.delay ){

                  transform( dragConfig[direction]["move"],"none" );
              }
              //移动过程中计算
              param.onMove && param.onMove.call(this,e,touch,module);

              e.stopPropagation();
            }
            
         }
         //松开手指以后执行
         function onend (e,touch) {

             //当前坐标
            var index = $(this).index(),
                scrollLeft = -index * itemWidth,
                scrollHeight = -index * itemHeight,
                deltaX = touch.x2-touch.x1,
                deltaY = touch.y2-touch.y1;

              dragConfig["x"]["delta"] = scrollLeft;
              dragConfig["x"]["absDelta"] = Math.abs(deltaX);
              
              dragConfig["y"]["delta"] = scrollHeight;
              dragConfig["y"]["absDelta"] = Math.abs(deltaY);

            if( dragConfig[direction]["absDelta"] > param.distance ){

                slide.call(this,touch,dragConfig);
                //结束的时候回调
                param.onEnd && param.onEnd.call(this,e,touch,module);

            }else if( dragConfig[direction]["absDelta"] < param.distance) {
              
                transform(dragConfig[direction]["delta"]);
            }

            // 如果是自动播放,需要先清除原来的时间重新计算
            if( param.autoplay ){
                autoPlay();
            }
         }

         //水平滚动
         function slide (touch,dragConfig) {
            
            //当前的焦点
            nowIndex = $(this).index();
            var index;

            if( touch.direction == dragConfig[direction].swipeDir ){

                //是否最后一页
                if ( nowIndex >= ($item.length-1) ){ index = nowIndex }else{ index = nowIndex+1 }
                
                dragConfig[direction]["delta"] = -index * dragConfig[direction]["width"];

                transform( dragConfig[direction]["delta"] );

                nowIndex = index;
                //添加激活的状态
                addStatus(index);
                
            }else if(touch.direction == dragConfig[direction].swipeDir2 ){
                //是否是第一个
                if ( nowIndex > 0 ){ index = nowIndex-1 }else{ index = nowIndex }

                dragConfig[direction]["delta"] = -index * dragConfig[direction]["width"];

                transform( dragConfig[direction]["delta"] );

                nowIndex = index;
                //添加激活的状态
                addStatus(index);

            }else{
                return;
            }
                    
         }

         //位移动画
         function transform (width,transition) {
            //默认时间
            var time = param.transition ,
                transition = transition || "all "+time+"ms",
                width = width || 0;
            
            switch(direction){
              case "x":
                uiTouch && uiTouch.move(width+"px",0,transition,$children);
              break;
              case "y":
                uiTouch && uiTouch.move(0,width+"px",transition,$children);
              break;
            }

            return this;
        }
        
        /**
         * 跳到第几个
         *  @method to
         *  @param {number} index [索引,从0开始]
         *  @param {string} [transition] [  "all 300ms"(不传则默认) | "none"(不要动画) | "all 300ms ease-out" (可以加上缓冲效果)]
         *  @chainable
         *  @example 
            
            //跳到第2个
            uiSlide.to(1);
                
         */
        function to (index,transition) {
            
            var index = parseInt(index);

            var movePosition = {
                x: {
                  transform: -index * parseFloat(itemWidth)
                },
                y: {
                  transform: -index * parseFloat(itemHeight)
                }
            }

            if( index >= $item.length || index < 0){
              return false;
            }


            transform( movePosition[direction]["transform"], transition);

            //更新状态
            nowIndex = index;
            addStatus( index );

            //如果是自动播放为true,跳转以后自动播放要继续
            if( param.autoplay ){
              autoPlay();
            }
            return this;
            
        }
        //自动播放
         function autoPlay (time) {
              var time = time || param.interval;
            
              stop();

              //修改自动播放的状态,在拖拽时时间才会重新计算
              param.autoplay = true;

              var index = nowIndex;
               interPlay = setInterval(function (argument) {
                  
                  if( index >= 0 && index < (length-1) ){

                      index = index + 1;

                  }else {
                      index = 0;
                  }

                  to(index);

               },time)
           
         }

         /**
         * 停止自动播放
         *  @method stop
         *  @chainable
         *  @example 
            
            //自动播放
            uiSlide.stop();
                
         */
         function stop (argument) {

           if( interPlay ){
              try{
                  
                  window.clearInterval(interPlay);

                  //更新自动播放的状态
                  param.autoplay = false;
              }catch(e){}
            }

             return this;
         }

        /**
         * 自动播放
         *  @method start
         *  @param {number} time [重新设置循环时间]
         *  @chainable
         *  @example 
            
            //自动播放
            uiSlide.start();
                
         */
         function start (time) {
            autoPlay(time);
         }

        /**
         * 上一个
         *  @method prev
         *  @chainable
         *  @example 
            
            uiSlide.prev();
                
         */
        function prev () {
            
            var index  = nowIndex -1;

            to(index);

            return this;
        }

        /**
         * 下一个
         *  @method next
         *  @chainable
         *  @example 
            
            uiSlide.next();
                
         */
        function next () {
            
            var index  = nowIndex +1;

            to(index);

            return this;
        }

        //添加当前状态
        function addStatus (index) {
            
            index = index || 0;
            $item.removeClass('active');
            $item.eq(index).addClass('active');

            $menuChildren.removeClass('active');
            $menuChildren.eq(index).addClass('active');
        }

         /**
         * 不允许拖拽
         *  @method lock
         *  @chainable
         *  @example 
            
            uiSlide.lock();
                
         */
         function lock () {

             uiTouch && uiTouch.off();
             return this;
         }

        /**
         * 允许拖拽
         *  @method unlock
         *  @chainable
         *  @example 
            
            uiSlide.unlock();
                
         */
         function unlock (argument) {
            
            //绑定拖拽
            uiTouch && uiTouch.on();

            return this;
        }

        //自动分页
        function templatePage (data,index) {
          var html = '';
          var index = index || 1;
          var i ;  
              html +='<div class="bui-slide-head">';
              html +='<ul >';
              for( i= 1; i< Number(data)+1; i++ ){
                  html += '<li '+ (i == index ? 'class="active"': "")+'>'+i+'</li>';
              }
              html +='</ul >';
              html +='</div >';

            return html;
        }

        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 ]
         *  @example 
            
            //获取依赖控件
            var uiSlideWidget = uiSlide.widget();
            
                
         */
        function widget(name) {
            var control = { touch: uiTouch };
            return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
             //获取所有参数
            var option = uiSlide.option();

            //获取某个参数
            var id = uiSlide.option( "id" );

            //修改一个参数
            uiSlide.option( "autoplay",false );

            //修改多个参数
            uiSlide.option( {"autoplay":false} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }

        return module;

    };

    return ui;

})( bui || {}, libs );
